import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Dispatch, SetStateAction } from 'react'
import { FormWithRedirect, SaveButton, useNotify, useRedirect } from 'react-admin'
import { TextInput } from 'shared/components/TextInput/TextInput'
import { Handler, HandlerOf } from 'shared/helpers/typeHelper'

import { Team } from 'models/team'
import { updateTeamLegalBusinessName } from '../../api/core'

type TeamNameChangeProps = {
  team: Team
  showDialog: boolean
  setShowDialog: Dispatch<SetStateAction<boolean>>
  handleClose: Handler
  inputValue: string | undefined
  onValueChange: HandlerOf<React.ChangeEvent<HTMLInputElement>>
}

export function TeamLegalBusinessNameChangeDialog({
  team,
  showDialog,
  setShowDialog,
  handleClose,
  inputValue,
  onValueChange,
}: TeamNameChangeProps) {
  const notify = useNotify()
  const redirect = useRedirect()

  const handleSave = async () => {
    if (!inputValue) {
      return notify('Please enter a name', { type: 'error' })
    }

    updateTeamLegalBusinessName(team.id, { legal_business_name: inputValue })
      .then((response) => {
        notify('Name updated!', { type: 'success' })
        setShowDialog(false)
        redirect(`/teams/${response.id}/show`)
      })
      .catch((error: any) => {
        notify(JSON.stringify(error.response.data), { type: 'error' })
      })
  }

  return (
    <Dialog fullWidth open={showDialog} onClose={handleClose} aria-label="Change Name Modal">
      <DialogTitle>Change Legal Business Name</DialogTitle>
      <FormWithRedirect
        resource="teams"
        save={handleSave}
        render={({ saving, handleSubmitWithRedirect }) => (
          <>
            <DialogContent>
              <TextInput label="New team name" value={inputValue} onChange={onValueChange} />
            </DialogContent>
            <DialogActions>
              <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} saving={saving} />
            </DialogActions>
          </>
        )}
      />
    </Dialog>
  )
}
